import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../data/content";

export const Navbar = ({ onBookVisit }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="nav-header-container"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#EAE0D5]/85 backdrop-blur-xl shadow-[0_4px_30px_rgba(31,41,30,0.08)]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 h-20 flex items-center justify-between">
        <a
          href="#hero"
          data-testid="nav-logo-link"
          onClick={(e) => {
            e.preventDefault();
            scrollTo("#hero");
          }}
          className="flex items-center gap-2 group"
        >
          <img
            src="/logo.png"
            alt="Aaroh Farms logo"
            className="h-14 w-14 object-contain bg-white/95 rounded-full p-1 shadow-md"
          />
        </a>

        <div className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(link.href);
              }}
              className={`text-sm font-medium tracking-wide transition-colors hover:text-[#C15B3D] ${
                scrolled ? "text-[#1F291E]" : "text-white/90 drop-shadow"
              }`}
            >
              {link.label}
            </a>
          ))}
          <button
            data-testid="nav-book-visit-button"
            onClick={onBookVisit}
            className="rounded-full bg-[#C15B3D] px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-[#C15B3D]/25 transition-all duration-300 hover:bg-[#A84C31] hover:shadow-xl hover:-translate-y-0.5"
          >
            Book a Site Visit
          </button>
        </div>

        <button
          className={`lg:hidden ${scrolled ? "text-[#2C5F2D]" : "text-white"}`}
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-[#EAE0D5]/97 backdrop-blur-xl border-t border-[#D5C8B8] px-6 py-6 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(link.href);
              }}
              className="text-base font-medium text-[#1F291E] py-1"
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={() => {
              setOpen(false);
              onBookVisit();
            }}
            className="mt-2 rounded-full bg-[#C15B3D] px-6 py-3 text-sm font-semibold text-white"
          >
            Book a Site Visit
          </button>
        </div>
      )}
    </header>
  );
};
